import { withI18n } from 'react-i18next';
import EmailInvoiceApplyCreditCard from './EmailInvoiceApplyCreditCard';

export const pureComponent = EmailInvoiceApplyCreditCard;
export default withI18n()(EmailInvoiceApplyCreditCard);
